import { FormControlLabel, SwitchProps, Typography, useTheme } from "@mui/material";
import { StyledSwitch, StyledSwitchBorder } from "src/components/inputs/senec-switch/SenecSwitch.styled";
import { SenecBaseTheme } from "src/styles/senecBaseTheme";

export type SenecSwitchProps = {
    /**
     * label - optional label to display next to switch
     */
    label?: string;

    /**
     * hasError - determines outline color of switch
     */
    hasError?: boolean;

    /**
     * variant - variant of switch
     */
    variant?: "outlined" | "filled";

    /**
     * Size of switch "small" or "medium"
     */
    size?: "small" | "medium";

    /**
     * data-testid - id to locate component while testing
     */
    "data-testid"?: string;
} & Omit<SwitchProps, "variant" | "size">;

export const SenecSwitch = ({
    "data-testid": dataTestId = "senec-switch",
    variant = "filled",
    size = "medium",
    hasError = false,
    ...props
}: SenecSwitchProps) => {
    const theme = useTheme() as SenecBaseTheme;

    return (
        <FormControlLabel
            value={props.label}
            label={
                <Typography
                    data-testid={`${dataTestId}-label`}
                    key={`${dataTestId}-label`}
                    color={variant === "outlined" ? theme.palette.white.main : theme.palette.neutralGray100.main}
                >
                    {props.label}
                </Typography>
            }
            labelPlacement="end"
            sx={{ margin: "0px" }}
            control={
                <StyledSwitchBorder data-testid={`${dataTestId}-border`} key={`${dataTestId}-border`} hasError={hasError}>
                    <StyledSwitch
                        {...props}
                        data-testid={dataTestId}
                        size={size}
                        variant={variant}
                        hasError={hasError}
                        onChange={props.onChange}
                    />
                </StyledSwitchBorder>
            }
        />
    );
};
